import { useRef } from "react"
import AboutUs from "../Screens/AboutUs"
import Advantages from "../Screens/Advantages"
import ContactUs from "../Screens/ContactUs"
import DataDriven from "../Screens/DataDriven"
import FAQS from "../Screens/FAQS"
import Footer from "../Screens/Footer"
import GetStarted from "../Screens/GetStarted"
import Intro from "../Screens/Intro"
import Logos from "../Screens/Logos"
import Navbar from "../Screens/Navbar"
import Rating from "../Screens/Ratings"
import Rentals from "../Screens/Rentals"
import Support from "../Screens/Support"
import SwiperCompcopy from "../Screens/SwiperComp"
import SwiperComp from "../Screens/SwiperComp"
import SwiperCard from "../Utils/SwiperCard"
import SwiperTrial from "../Utils/Swipertrial"

const Home=()=>
{
    const mycontactref=useRef(null)
    return(
        <>
            <Navbar/>
            <Intro mycontactref={mycontactref}/>
            <AboutUs />
            <Rentals />
            {/* <DataDriven /> */}
            <Support />
            <Advantages />
            <SwiperComp />
            <Logos />
            <Rating />
            <GetStarted mycontactref={mycontactref} />
            <FAQS mycontactref={mycontactref} />
            <ContactUs />
            <Footer />
        </>
    )
}
export default Home